<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9GBai2/tc-custom/9781451606874.jpg?1730537806683" alt="This image is the cover for the book Killing Time, One-Eyed Jacks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Killing Time, One-Eyed Jacks
      </h1>
      <p class="bookDescription body article font2">
        <b>First of the One-Eyed Jack series from bestselling author Cindy Gerard, <i>Killing Time</i> is packed with action, romance, and the search for the truth "in this addition to her unique and successful brand of special-ops romantic suspense" (<i>Kirkus Reviews</i>).</b><br/><br/><i>New York Times </i>and <i>USA Today </i>bestselling author Cindy Gerard plunges readers into the heart of a seductive contest of wills between a hard-living hero and a beautiful rogue operative who is on a mission to dig up the secrets of his past. Tension sizzles in this pulse-pounding first adventure in Gerard’s action-packed new series as Eva Salinas lures Mike Brown from the sultry streets of Lima, Peru, to the desolate Idaho wilderness on the hunt for the cold-blooded traitor behind a fatal military operation that haunts them both.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cindy Gerard
      </h2>
      
      <p class="authorDescription body article">Cindy Gerard<B></B>is the critically acclaimed <I>New York Times </I>and <I>USA Today </I>bestselling author of the wildly popular Black Ops series,&#160;the Bodyguards series,&#160;and more than thirty contemporary romance novels. Her latest books include the One-Eyed Jacks novels<I> Killing Time, Running Blind, </I>and <I>The Way Home. </I>Her work has won the prestigious RITA Award for Best Romantic Suspense. She and her husband live in the Midwest. Visit her online at CindyGerard.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ef659e9